/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_New_ConversationInputs */

const en_us2_coach_extra_new_conversation = /** @type {(inputs: Coach_Extra_New_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New conversation`)
};

const pt_br2_coach_extra_new_conversation = /** @type {(inputs: Coach_Extra_New_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova conversa`)
};

const es_419_coach_extra_new_conversation = /** @type {(inputs: Coach_Extra_New_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva conversación`)
};

const pt_pt2_coach_extra_new_conversation = /** @type {(inputs: Coach_Extra_New_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova conversa`)
};

const fr_fr2_coach_extra_new_conversation = /** @type {(inputs: Coach_Extra_New_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle conversation`)
};

const de_de2_coach_extra_new_conversation = /** @type {(inputs: Coach_Extra_New_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Unterhaltung`)
};

const it_it2_coach_extra_new_conversation = /** @type {(inputs: Coach_Extra_New_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova conversazione`)
};

/**
* | output |
* | --- |
* | "New conversation" |
*
* @param {Coach_Extra_New_ConversationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_new_conversation = /** @type {((inputs?: Coach_Extra_New_ConversationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_New_ConversationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_new_conversation(inputs)
	if (locale === "es-419") return es_419_coach_extra_new_conversation(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_new_conversation(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_new_conversation(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_new_conversation(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_new_conversation(inputs)
	return en_us2_coach_extra_new_conversation(inputs)
});
export { coach_extra_new_conversation as "coach-extra.new_conversation" }